import { useState } from 'react'
import { eventSocialService } from '../services/friendsService'

export const useComments = (eventId, initialComments = []) => {
  const [comments, setComments] = useState(initialComments)
  const [loading, setLoading] = useState(false)

  const addComment = async (text) => {
    setLoading(true)
    try {
      const response = await eventSocialService.addComment(eventId, text)
      setComments([...comments, response.comment])
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error adding comment:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteComment = async (commentId) => {
    if (!window.confirm('Are you sure you want to delete this comment?')) {
      return
    }

    try {
      await eventSocialService.deleteComment(eventId, commentId)
      setComments(comments.filter(comment => comment._id !== commentId))
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error deleting comment:', error)
      throw error
    }
  }

  const editComment = async (commentId, text) => {
    try {
      const response = await eventSocialService.editComment(eventId, commentId, text)
      setComments(comments.map(comment =>
        comment._id === commentId
          ? { ...comment, text: response.comment.text, updatedAt: response.comment.updatedAt }
          : comment
      ))
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error editing comment:', error)
      throw error
    }
  }

  const addReaction = async (commentId, emoji) => {
    try {
      const response = await eventSocialService.addCommentReaction(eventId, commentId, emoji)
      setComments(comments.map(comment =>
        comment._id === commentId ? response.comment : comment
      ))
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error adding reaction:', error)
      throw error
    }
  }

  const removeReaction = async (commentId) => {
    try {
      const response = await eventSocialService.removeCommentReaction(eventId, commentId)
      setComments(comments.map(comment =>
        comment._id === commentId ? response.comment : comment
      ))
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error removing reaction:', error)
      throw error
    }
  }

  return {
    comments,
    loading,
    addComment,
    deleteComment,
    editComment,
    addReaction,
    removeReaction
  }
}